<template>
  <router-view />
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import $ from "jquery";

onMounted(async () => {
  // Функция для загрузки скрипта
  // const loadScript = (src: string): Promise<void> => {
  //   return new Promise((resolve, reject) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.async = true;
  //     script.onload = () => {
  //       console.log(`${src} загружен`);
  //       resolve();
  //     };
  //     script.onerror = () => reject(new Error(`Не удалось загрузить ${src}`));
  //     document.body.appendChild(script);
  //   });
  // };
  // try {
  //   // 1. Загружаем jQuery
  //   await loadScript("https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js");
  //   if (!window.jQuery) throw new Error("jQuery не инициализирован");
  //   // 2. Загружаем webflow.js
  //   await loadScript("/webflow.js"); // Убедитесь, что путь правильный
  //   if (!window.Webflow) throw new Error("Webflow не инициализирован");
  //   // 3. Инициализируем Webflow
  //   window.Webflow.ready();
  //   const ix2 = window.Webflow.require("ix2");
  //   if (ix2) {
  //     ix2.init();
  //     console.log("Webflow IX2 инициализирован");
  //   } else {
  //     console.warn("IX2 не найден");
  //   }
  // } catch (error) {
  //   console.error("Ошибка загрузки скриптов:", error);
  // }
});
</script>
<style lang="scss">
// @import url(@/assets/css/normalize.css);
// @import url(@/assets/css/webflow.css);
// @import url(@/assets/css/swipez--new.webflow.css);
</style>
<style>
body {
  -webkit-overflow-scrolling: touch;
}
</style>
<!--  Please keep this css code to improve the font quality -->
<style>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<style>
body {
  overscroll-behavior: none;
}
</style>
<style>
input,
textarea {
  -webkit-appearance: none;
  border-radius: 0;
}
</style>
<style>
::-moz-selection {
  /* Firefox */
  color: #000000;
  background: #fcd713;
}

::selection {
  color: #000000;
  background: #fcd713;
}
</style>
<style>
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
  -webkit-border-radius: 0px;
  background: #000000;
  border-radius: 0px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 0px;
  border-radius: 0px;
  background: #fcd713;
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #000000;
}
</style>
